import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function initSection() {
  const sections = document.querySelectorAll(".section")
  const translationY = 220

  sections.forEach((section, index) => {
    const nextSection = sections[index + 1]
    const isLastSection = !nextSection
    const nextIsRounded =
      nextSection && nextSection.classList.contains("rounded-top")

    if (section.classList.contains("section__hero")) return

    if (section.classList.contains("no-effect")) {
      if (nextIsRounded) {
        ScrollTrigger.create({
          trigger: section,
          start: "center center",
          end: "bottom top",
          onEnter: () => {
            section.style.zIndex = 1
            nextSection.style.zIndex = 2
          },
          onLeaveBack: () => {
            section.style.zIndex = 2
            nextSection.style.zIndex = 1
          },
        })
      }
      return
    }

    if (!(isLastSection || nextIsRounded)) return

    const content = section.querySelector("div:first-child")

    const originalPaddingBottom = window.getComputedStyle(content).paddingBottom
    const originalPaddingBottomPx = parseFloat(originalPaddingBottom) || 0

    const MIN_PADDING = 140
    const MAX_PADDING = 160
    const CONTENT_RATIO = 0.4

    let lastApplied = null

    const updatePadding = () => {
      let next

      if (window.innerWidth <= 1024) {
        next = originalPaddingBottom
      } else {
        const currentPaddingPx =
          parseFloat(content.style.paddingBottom) || originalPaddingBottomPx
        const naturalHeight = content.scrollHeight - currentPaddingPx
        const capped = Math.max(
          MIN_PADDING,
          Math.min(MAX_PADDING, Math.round(naturalHeight * CONTENT_RATIO))
        )
        next = `${capped}px`
      }

      if (next === lastApplied) return

      content.style.paddingBottom = next
      lastApplied = next
    }

    updatePadding()

    window.addEventListener("resize", updatePadding)

    function triggerGsapAnimation() {
      gsap.to(content, {
        y: translationY,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top center",
          end: "bottom top",
          scrub: 1,
          onEnter: () => {
            section.style.zIndex = 1
            if (nextSection) nextSection.style.zIndex = 2
          },
          onLeaveBack: () => {
            section.style.zIndex = 2
            if (nextSection) nextSection.style.zIndex = 1
          },
        },
      })
    }

    triggerGsapAnimation()
  })

  const allSections = document.querySelectorAll(".section")
  if (allSections.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.dispatchEvent(new Event("resize"))
          }
        })
      },
      { threshold: 0.1 }
    )

    allSections.forEach((section) => {
      observer.observe(section)
    })
  }
}
